/**
 * Recent orders module
 *
 * This module provides functions around recent orders component on homepage.
 * - Virtual detail page generation (render/window history)
 *
 */

import { MUAPP } from 'account/api';
import { orderObjectReducer } from 'account/utils';

custom.recentOrders = (() => {
  // Static variables
  const listClassName = 'js-recent-orders-list';

  /**
   * renderOrdersList
   *
   * @param {object} orders - spars order data
   */
  const renderOrdersList = (orders) => {
    if (!$(`.${listClassName}`)) return;
    const $ordersList = $(`.${listClassName}`);
    let output = '';

    // If no orders, leave the list empty
    if (orders.length > 0) {
      let containerClass;
      //if only 1 order make it 9/12 width
      if (orders.length == 1) {
        containerClass =
          'medium-up--eight-twelfths large-up--push-three-twelfths large-up--nine-twelfths';
      } else {
        containerClass = 'medium-up--six-twelfths';
      }
      orders.forEach((order, index, arr) => {
        // Container Class
        arr[index].containerClass = containerClass;
        // Total items
        arr[index].TotalItems = order.Header.TotalItems;
        // Product Images, shows only first 1
        arr[index].Detail = order.Detail.slice(0, 1);
        arr[index].Detail.forEach((detail) => {
          if (!detail.ShopifyItem.image) {
            detail.ShopifyItem.image = orderNoImgSrc;
            detail.imageless = true;
          } else {
            detail.imageless = false;
          }
        });
        // To add additional attributes in order object
        arr[index] = orderObjectReducer(order);
        output += window.recentOrderCardTemplate
          ? window.recentOrderCardTemplate.render(arr[index])
          : JSON.parse(arr[index]);
      });
      $ordersList.html('').append(output);
    }
  };

  /**
   * store pdp to customer metafield
   *
   */
  const store = (pdp) => {
    if (pdp) {
      //check if page already exists in cache
      if (window.MUAPP.common.Shopify.customer.pdps.indexOf(pdp) < 0) {
        MUAPP.customer
          .customerPDP(pdp)
          .then((data) => {
            //console.log(data);
            window.MUAPP.common.Shopify.customer.pdps = data.pdps;
          })
          .catch((err) => {
            console.log(err);
          });
      }
    }
  };

  /**
   * Initialize
   *
   */
  const init = () => {
    if ($('.js-recent-orders').length > 0) {
      //get last 2 orders
      let request = new Object();
      const today = new Date();
      const allDate = new Date('January 1, 2010');
      request['DateTo'] = today.toISOString().split('T')[0];
      request['DateFrom'] = allDate.toISOString().split('T')[0];
      request['PerPage'] = 2;
      request['Page'] = 1;
      MUAPP.orders
        .getOrders(request)
        .then((data) => {
          renderOrdersList(data.orders);
        })
        .catch((err) => {
          const $ordersList = $(`.${listClassName}`);
          const output = `<div class="grid__item">
            <div class="text-center py-6 px-3 md-up:py-12 md-up:px-0 bg-grey-1">
              <h3 class="title-medium spacer--1--mb">Unable to retrieve recent orders.</h3>
              <p class="body-medium spacer-2--mb mx-auto">Please try again later.</p>
              <a href="/collections/rugs-all" class="btn btn--tertiary">Explore Rugs</a>
            </div>
          </div>`;
          $ordersList.html('').append(output);
        });
    }
  };

  return {
    init,
    store,
  };
})();



// WEBPACK FOOTER //
// ./src/scripts/src/account/recent-orders.js